
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"currentColor","d":"M11.5 4.075c-3.985 0-7.216 3.245-7.216 7.246a7.242 7.242 0 004.961 6.88v4.44h.902V24h2.706v-1.358h.902V18.2a7.242 7.242 0 004.96-6.88c0-4-3.23-7.245-7.215-7.245zM11.5 0a.451.451 0 00-.451.453v1.811a.451.451 0 10.902 0V.453A.451.451 0 0011.5 0zm10.824 10.868H20.52a.451.451 0 00-.451.453c0 .25.201.453.45.453h1.805c.249 0 .45-.203.45-.453a.451.451 0 00-.45-.453zm-19.844 0H.676a.451.451 0 00-.45.453c0 .25.201.453.45.453H2.48c.25 0 .451-.203.451-.453a.451.451 0 00-.45-.453zm16.355-7.552l-1.276 1.28a.454.454 0 00.32.773c.115 0 .23-.044.318-.132l1.275-1.281a.454.454 0 000-.64.45.45 0 00-.637 0zM4.803 17.405l-1.275 1.28a.454.454 0 00.318.774.454.454 0 00.32-.133l1.275-1.28a.454.454 0 000-.641.45.45 0 00-.638 0zm13.394 0a.45.45 0 00-.638 0 .454.454 0 000 .64l1.276 1.28a.449.449 0 00.637 0 .454.454 0 000-.64l-1.275-1.28zM4.165 3.316a.45.45 0 00-.637 0 .454.454 0 000 .64l1.275 1.28a.449.449 0 00.638 0 .454.454 0 000-.64l-1.276-1.28z"}}),_c('path',{attrs:{"fill":"#FFF3C1","d":"M6.54 11.774a.451.451 0 01-.452-.453c0-2.997 2.428-5.434 5.412-5.434a.45.45 0 01.451.453c0 .25-.202.452-.451.452-2.487 0-4.51 2.032-4.51 4.529 0 .25-.201.453-.45.453z"}}),_c('path',{attrs:{"fill":"#4B4D56","d":"M9.245 19.472v3.17h.902V24h2.706v-1.358h.902v-3.17z"}})])])
          )
        }
      }
    